/**
 * Routes rendered inside the Staff Portal v2 shell (StaffPortalShell).
 * When staff_portal_v2_enabled is on, the legacy AppShell chrome must NOT
 * double-wrap these — AppShell passes children through so the route's own
 * StaffPortalShell renders alone.
 *
 * Extracted from AppShell.js so the matcher is unit-testable without pulling
 * in react-router / the full shell tree.
 */
export const STAFF_V2_PATH_PREFIXES = [
  '/staff/dashboard', '/staff/roster', '/staff/open-shifts', '/staff/policies',
  '/staff/my-participants', '/staff/participants', '/staff/handovers', '/staff/learning', '/staff/payroll',
  '/staff/tasks', '/staff/resources',
  '/staff/employment', '/my/', '/notifications', '/compliance/incidents',
  '/timesheets/my-v2', '/portal/leave', '/portal/availability',
  '/staff/shift', '/portal/shift', '/staff/attachments', '/staff/transport',
  '/accommodation/houses',
];

export function isStaffV2Path(pathname) {
  if (pathname === '/settings' || pathname === '/my/work') return true;
  return STAFF_V2_PATH_PREFIXES.some((p) => pathname === p || pathname.startsWith(p.endsWith('/') ? p : `${p}/`) || pathname === p.replace(/\/$/, ''));
}

/**
 * Routes that are legitimately reachable from BOTH the admin sidebar and the
 * staff portal (shared functionality). On these, the shell is decided by the
 * caller's role — elevated/management roles keep the admin AppShell, Support
 * Workers keep the Staff Portal shell. Everything else keeps its existing
 * flag-driven behaviour untouched.
 */
export const SHARED_ADMIN_STAFF_PREFIXES = [
  '/compliance/incidents', '/notifications', '/staff/policies',
  '/accommodation/houses',
];

export function isSharedAdminStaffPath(pathname) {
  return SHARED_ADMIN_STAFF_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}
